import Icon from '@ant-design/icons'
import * as React from 'react'

import { NovaIconProps } from '../types/iconTypes'

const Close = (props: NovaIconProps) => (
  <Icon
    {...props}
    component={() => (
      <svg
        width="1em"
        height="1em"
        focusable={false}
        viewBox="2 2 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.2313 15.9995L25.6991 8.55603C26.0951 8.16137 26.1011 7.51584 25.7121 7.11404L24.9292 6.30534C24.5402 5.90355 23.904 5.89743 23.508 6.29209L16 13.7753L8.49205 6.29209C8.09604 5.89743 7.45976 5.90355 7.0708 6.30534L6.2879 7.11404C5.89894 7.51584 5.90491 8.16137 6.30091 8.55603L13.7687 15.9995L6.30091 23.444C5.90491 23.8386 5.89894 24.4842 6.2879 24.886L7.0708 25.6947C7.45976 26.0965 8.09604 26.1026 8.49205 25.7079L16 18.2247L23.508 25.7079C23.904 26.1026 24.5402 26.0965 24.9292 25.6947L25.7121 24.886C26.1011 24.4842 26.0951 23.8386 25.6991 23.444L18.2313 15.9995Z"
          fill="currentColor"
        />
      </svg>
    )}
  />
)

export default Close
